import React, {PropTypes} from 'react'
import Display from '../parts/display'
import Checkbox from '../parts/checkbox'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import $ from 'jquery'
import {TimelineLite} from 'gsap'
import * as siteActions from '../../actions/siteActions'
import { ScrollToPlugin } from 'gsap'
import _find from 'lodash/find'
import _without from 'lodash/without'
import _unescape from 'lodash/unescape'
import { browserHistory, Link } from 'react-router'
import Slider from 'react-rangeslider'
import is from 'is_js'

class StartProjectPage extends React.Component {
  constructor () {
    super()
    this.state = {
      animated: false,
      selected: '',
      pageSlug: false,
      project: true,
      sector: [],
      objective: '',
      services: [],
      brief: false,
      briefContent: '',
      preference: [],
      timeScale: 4,
      timeScaleText: '3 month',
      page: 0,
      name: '',
      email: '',
      company: '',
      phone: '',
      additionalInfo: '',
      validation: [],
      message: false
    }
    this.checkBoxes = this.checkBoxes.bind(this)
    this.updateChecks = this.updateChecks.bind(this)
    this.updateObjectives = this.updateObjectives.bind(this)
    this.updateObjective = this.updateObjective.bind(this)
    this.handleRangeChange = this.handleRangeChange.bind(this)
    this.trueFalse = this.trueFalse.bind(this)
    this.formatList = this.formatList.bind(this)
    this.updateField = this.updateField.bind(this)
    this.tl = new TimelineLite()
    this.send = this.send.bind(this)
  }
  componentWillMount () {
        // window.scrollTo(0,0);
    $('body').css({
      overflowY: 'hidden',
      height: '100vh'
    })
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.site.sentStartProject !== nextProps.site.sentStartProject) {
      this.setState({
        message: 'Thank you for your enquiry, we will be in touch very soon.'
      })
      setTimeout(() => {
        this.props.location.state ? this.props.location.state.returnTo ? browserHistory.push(this.props.location.state.returnTo) : browserHistory.push('/') : browserHistory.push('/')
      }, 4000)
    }
  }
  componentDidMount () {
    var _this = this
    this.props.actions.showNavBar(true)
    this.props.actions.showMenu(true)

    if (this.props.site.posts.length < 4) {
      this.props.actions.loadBlogPosts(3, 1)
    }
    if (this.props.location.query.type && this.props.site.services.length > 0) {
      this.updateChecks(_find(this.props.site.services, {slug: this.props.location.query.type}).name, true, 'sector')
      _this.changePage(1)
    }

    let n = 0,
      hover = false,
      initialScroll = false

    $('.project-section, .page-circles').mouseover(function () {
      hover = true
      if ($(this).attr('data-page') == 1 && _this.state.page < 1 && !initialScroll) {
        _this.changePage(1)
        initialScroll = true
      }
      _this.setState({
        page: Number($(this).attr('data-page'))
      })
    })

    $('.project-section, .page-circles').mouseout(function () {
      hover = false
    })

    $('.beta-tag').hide()
  }
  componentWillUnmount () {
        // this.enableScroll();
    $('body').css({
      overflowY: 'auto',
      height: 'auto'
    })
    $('.beta-tag').show()
  }
  decodeHtml (html) {
    var txt = document.createElement('textarea')
    txt.innerHTML = html
    return txt.value
  }
  preventDefault (e) {
    e = e || window.event
    if (e.preventDefault) {
      e.preventDefault()
    }
    e.returnValue = false
  }
  preventDefaultForScrollKeys (e) {
    let keys = {37: 1, 38: 1, 39: 1, 40: 1}
    if (keys[e.keyCode]) {
      this.preventDefault(e)
      return false
    }
  }
  disableScroll () {
    if (window.addEventListener) // older FF
          {
      window.addEventListener('DOMMouseScroll', this.preventDefault, false)
    }
    window.onwheel = this.preventDefault // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault // older browsers, IE
    window.ontouchmove = this.preventDefault // mobile
    document.onkeydown = this.preventDefaultForScrollKeys
  }
  enableScroll () {
    if (window.removeEventListener) { window.removeEventListener('DOMMouseScroll', this.preventDefault, false) }
    window.onmousewheel = document.onmousewheel = null
    window.onwheel = null
    window.ontouchmove = null
    document.onkeydown = null
  }
  changePage (n) {
    this.tl.to('#project-page', 0.6, {scrollTo: '#project-section-' + n, onComplete: () => {
      this.setState({
        page: n
      })
    }})
  }
  updateObjectives (val, checked) {
    if (checked) {
      let list = this.state.objectives
      list.push(val)
      this.setState({
        objectives: list
      })
    } else {
      this.setState({
        objectives: _without(this.state.objectives, val)
      })
    }
  }
  updateObjective (e) {
    this.setState({
      objective: e.target.value
    })
  }
  updateChecks (val, checked, state) {
    if (checked) {
      let list = this.state[state]
      list.push(_unescape(val))
      this.setState({
        [state]: list
      })
    } else {
      this.setState({
        [state]: _without(this.state[state], _unescape(val))
      })
    }
  }
  formatList (arr) {
    if (arr.length > 1) {
      var s = arr.slice(0, arr.length - 1).join(', ') + ', and ' + arr.slice(-1)
      return s
    } else if (arr.length === 1) {
      return arr[0]
    } else {
      return false
    }
  }
  checkBoxes (service, index) {
    let state
    service.taxonomy === 'skillset' ? state = 'services' : state = 'sector'
    return <Checkbox key={index} label={service.name} name='service' value={service.name} handleChange={(val, check) => this.updateChecks(val, check, state)} checked={this.props.location.query.type === service.slug} />
  }
  handleRangeChange (value) {
    let txt
    switch (value) {
      case 1: txt = '2 Weeks'
        break
      case 2: txt = '4 Weeks'
        break
      case 3: txt = '2 Month'
        break
      case 4: txt = '3 Month'
        break
      case 5: txt = '5 Month'
        break
      case 6: txt = '6 Month'
        break
      case 7: txt = '6 Month - 1 Year'
        break
      case 8: txt = '1 Year+'
        break
      case 9: txt = 'No Timescale'
        break
      case 10: txt = 'Not Sure'
        break
    }
    this.setState({
      timeScale: value,
      timeScaleText: txt
    })
  }
  updateField (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  trueFalse (val) {
    this.setState({
      brief: val
    })
  }
  updatePage (n) {
    this.setState({
      page: n
    })
  }
  send () {
    let validation = []
    this.setState({
      validation: validation
    }, () => {
      if (this.state.objective.length < 1) {
        validation = validation.concat(['Please write and objective'])
      }
            // if(this.state.services.length < 1){
            //     validation = validation.concat(['Please choose a service']);
            // }
      if (this.state.brief) {
        if (this.state.briefContent.length < 1) {
          validation = validation.concat(['Please add your written brief'])
        }
      }
      if (this.state.name.length < 1) {
        validation = validation.concat(['Please add your name'])
      }
      if (this.state.email.length < 1 || !is.email(this.state.email)) {
        validation = validation.concat(['Please add a valid email address'])
      }

      this.setState({
        validation: validation
      }, () => {
        if (this.state.validation.length < 1) {
          this.props.actions.sendStartProject({
            input_values: {
              input_1: this.state.objective,
              input_7: this.state.services.join(),
              input_14: this.state.sector.join(),
              input_4: this.state.timeScaleText,
              input_8: this.state.briefContent ? this.state.briefContent : 'No',
              input_6: this.state.preference.join(),
              input_9: this.state.name,
              input_10: this.state.company,
              input_11: this.state.email,
              input_12: this.state.phone,
              input_13: this.state.additionalInfo
            }
          })
        }
      })
    })
  }

  render () {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true
    }
    return (
      <div className='services-page animated fadeIn portfolio-page contact-page start-project-page' id='project-page'>
        <Link to={{
          pathname: this.props.location.state ? this.props.location.state.returnTo ? this.props.location.state.returnTo : '/' : '/',
          state: false
        }} className='close' />
        <Display if={this.state.page > 0} className='page-circles'>
          {/* <div className={this.state.page == 1? "circle active": "circle"} onClick={()=>this.changePage(1)}><span>Interests</span></div> */}
          <div ref='objectiveCircle' className={this.state.page == 2 ? 'circle active' : 'circle'} onClick={() => this.changePage(2)}><span>Objectives</span></div>
          <div className={this.state.page == 3 ? 'circle active' : 'circle'} onClick={() => this.changePage(3)}><span>Services</span></div>
          <div className={this.state.page == 4 ? 'circle active' : 'circle'} onClick={() => this.changePage(4)}><span>Timescale</span></div>
          <div className={this.state.page == 5 ? 'circle active' : 'circle'} onClick={() => this.changePage(5)}><span>Brief</span></div>
          <div className={this.state.page == 6 ? 'circle active' : 'circle'} onClick={() => this.changePage(6)}><span>Contact</span></div>
          <div className={this.state.page == 7 ? 'circle active' : 'circle'} onClick={() => this.changePage(7)}><span>Personal</span></div>
        </Display>
        <div className='page-content'>
          {/* <div className="project-section" data-page="1" id="project-section-1"> */}
          {/* <div className="container"> */}
          {/* <div className="row"> */}
          {/* <h3>What are you interested in?</h3> */}
          {/* <div className="col-md-6"> */}
          {/* {this.props.site.specialisms.map(this.checkBoxes)} */}
          {/* <Checkbox label="Not Sure" name="service" value="Not Sure" handleChange={this.updateChecks} /> */}
          {/* </div> */}
          {/* <div className="down-arrow" onClick={()=>this.changePage(2)}> */}
          {/* <i className="fa fa-angle-down"></i> */}
          {/* <span>Objectives</span> */}
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}
          <div className='project-section' data-page='2' id='project-section-2'>
            <div className='container'>
              <div className='row'>
                <p className='welcome-message'>We would really like to help you with your <span dangerouslySetInnerHTML={{__html: this.props.location.query.type ? _find(this.props.site.services, {slug: this.props.location.query.type}).name + ' ' : ''}} />project, to get started we have 5 questions, please answer below.</p>

                <h3>What is your main objective?</h3>
                <div className='col-md-6'>
                  <div className='input-wrapper'>
                    <input type='text' placeholder='Please describe e.g increase sales' onChange={this.updateObjective} />
                  </div>
                </div>
                <div className='col-md-6' />
                {/* <div className="up-arrow" onClick={()=>this.changePage(1)}> */}
                {/* <i className="fa fa-angle-up"></i> */}
                {/* <span>Interests</span> */}
                {/* </div> */}
                <div className='down-arrow' onClick={() => this.changePage(3)}>
                  <i className='fa fa-angle-down' />
                  <span>Services</span>
                </div>
              </div>
            </div>
          </div>
          <div className='project-section' data-page='3' id='project-section-3'>
            <div className='container'>
              <div className='row'>
                <h3>What services do you think you require?</h3>
                <div className='col-md-6'>
                  {this.props.site.skillsets.map(this.checkBoxes, 'services')}
                  <Checkbox label='Other' name='service' value='Other' handleChange={(val, check) => this.updateChecks(val, check, 'services')} />
                  <Checkbox label='Not Sure' name='service' value='Not Sure' handleChange={(val, check) => this.updateChecks(val, check, 'services')} />
                </div>
                <div className='col-md-6' />
                <div className='down-arrow' onClick={() => this.changePage(4)}>
                  <span>Timescale</span>
                  <i className='fa fa-angle-down' />
                </div>
                <div className='up-arrow' onClick={() => this.changePage(2)}>
                  <i className='fa fa-angle-up' />
                  <span>Objectives</span>
                </div>
              </div>
            </div>
          </div>
          <div className='project-section' data-page='4' id='project-section-4'>
            <div className='container'>
              <div className='row'>
                <h3>What are your timescales?</h3>
                <Slider
                  value={this.state.timeScale}
                  min={1}
                  max={10}
                  onChange={this.handleRangeChange} />
                <p>{this.state.timeScaleText}</p>
                <div className='down-arrow' onClick={() => this.changePage(5)}>
                  <i className='fa fa-angle-down' />
                  <span>Brief</span>
                </div>
                <div className='up-arrow' onClick={() => this.changePage(3)}>
                  <i className='fa fa-angle-up' />
                  <span>Services</span>
                </div>
              </div>
            </div>
          </div>
          <div className='project-section' data-page='5' id='project-section-5'>
            <div className='container'>
              <div className='row'>
                <h3>Do you have a written brief?</h3>
                <Checkbox label='Yes' name='written-brief' checked={this.state.brief} value handleChange={() => this.trueFalse(true)} />
                <Display if={this.state.brief}>
                  {/* <input type="file" name="pic" accept="application/pdf,application/msword, */}
                  {/* application/vnd.openxmlformats-officedocument.wordprocessingml.document"/> */}
                  <div className='input-wrapper'>
                    <textarea placeholder='Please add written brief' rows='4' name='briefContent' onChange={this.updateField} value={this.state.briefContent} />
                  </div>
                </Display>
                <Checkbox label='No' name='written-brief' checked={!this.state.brief} value={false} handleChange={() => this.trueFalse(false)} />
                <div className='down-arrow' onClick={() => this.changePage(6)}>
                  <i className='fa fa-angle-down' />
                  <span>Contact</span>
                </div>
                <div className='up-arrow' onClick={() => this.changePage(4)}>
                  <i className='fa fa-angle-up' />
                  <span>Timescale</span>
                </div>
              </div>
            </div>
          </div>
          <div className='project-section' data-page='6' id='project-section-6'>
            <div className='container'>
              <div className='row'>
                <h3>Would you like?</h3>
                <Checkbox label='Initial free price estimate' name='written-brief' value='Initial free price estimate' handleChange={(val, check) => this.updateChecks(val, check, 'preference')} />
                <Checkbox label='Initial free consultation meeting' name='written-brief' value='Initial free consultation meeting' handleChange={(val, check) => this.updateChecks(val, check, 'preference')} />
                <Checkbox label='Telephone conversation' name='written-brief' value='Telephone conversation' handleChange={(val, check) => this.updateChecks(val, check, 'preference')} />
                <Checkbox label='More Information' name='written-brief' value='More Information' handleChange={(val, check) => this.updateChecks(val, check, 'preference')} />
                <Checkbox label='Other' name='written-brief' value='Other' handleChange={(val, check) => this.updateChecks(val, check, 'preference')} />
                <div className='up-arrow' onClick={() => this.changePage(5)}>
                  <i className='fa fa-angle-up' />
                  <span>Brief</span>
                </div>
                <div className='down-arrow' onClick={() => this.changePage(7)}>
                  <i className='fa fa-angle-down' />
                  <span>Personal</span>
                </div>
              </div>
            </div>
          </div>
          <div className='project-section review' data-page='7' id='project-section-7'>
            <div className='container'>
              <div className='row'>
                <h3>Review and send</h3>
                <p>Please add your personal contact details and check over the following statement before sending.</p>
                <div className='row'>
                  <div className='col-md-6 personal-details'>
                    <div className='input-wrapper'>
                      <input type='text' className={this.state.name.length > 0 ? ' valid' : ''} placeholder='Name' name='name' onChange={this.updateField} value={this.state.name} />
                    </div>
                    <div className='input-wrapper'>
                      <input type='text' className={this.state.company.length > 0 ? ' valid' : ''} placeholder='Company' name='company' onChange={this.updateField} value={this.state.company} />
                    </div>
                    <div className='input-wrapper'>
                      <input type='email' className={is.email(this.state.email) ? ' valid' : ''} placeholder='Email' name='email' onChange={this.updateField} value={this.state.email} />
                    </div>
                    <div className='input-wrapper'>
                      <input type='phone' className={this.state.phone.length > 0 ? 'valid' : ''} placeholder='Phone' name='phone' onChange={this.updateField} value={this.state.phone} />
                    </div>
                    <div className='input-wrapper'>
                      <textarea placeholder='Additional information' rows='6' name='additionalInfo' onChange={this.updateField} value={this.state.additionalInfo} />
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <p>Hi Indigo,</p>
                    <div className='message-paragraph'><Display if={this.state.sector.length > 0}>I am interested in <strong>{this.formatList(this.state.sector)}</strong>.</Display>
                      <Display if={this.state.objective}>My main objective is to <strong>{this.state.objective}</strong></Display> <Display if={this.state.services.length > 0}>I think my project will need <strong>{this.formatList(this.state.services)}</strong>.</Display> I have a timescale of <strong>{this.state.timeScaleText}</strong> and <strong>{this.state.brief ? 'do' : "don't"}</strong> have a written brief.<Display if={this.state.preference.length > 0}> Please contact me regarding <strong>{this.formatList(this.state.preference)}</strong>.</Display></div>
                    <p>{this.state.additionalInfo}</p>
                    <p>Regards,</p>
                    <p>
                      <strong>{this.state.name}</strong><br />
                      <strong>{this.state.company}</strong><br /><br />
                      {this.state.email}<br />
                      {this.state.phone}<br /><br />
                    </p>
                  </div>
                  <div className='col-md-12 start-project-submit-area'>
                    <Display if={this.state.validation.length > 0} className='validation'>
                      {this.state.validation.map((val, i) => {
                        return <p key={i}>{val}</p>
                      })}
                    </Display>
                    <Display if={this.state.message} className='message'>
                      {this.state.message}
                    </Display>
                    <Display if={!this.state.message}>
                      <div className={this.props.site.sendingStartProject ? 'btn start-project-submit sending' : 'btn start-project-submit'}
                        onClick={this.props.site.sendingStartProject ? null : this.send}>
                        {this.props.site.sendingStartProject ? 'Sending...' : 'Start my project'}
                      </div>
                    </Display>
                  </div>
                </div>
                <div className='up-arrow' onClick={() => this.changePage(6)}>
                  <i className='fa fa-angle-up' />
                  <span>Contact</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    site: state.site
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(siteActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StartProjectPage)



/** WEBPACK FOOTER **
 ** ./src/js/components/contact/startProjectPage.js
 **/